import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
};

// Single MSAL instance shared by MsalProvider and ApiCall. MsalProvider calls initialize() on it.
export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
    scopes: process.env.REACT_APP_SCOPES ? process.env.REACT_APP_SCOPES.split(',') : [],
};
